<template>
  <img :src="src" @load="onLoad" />
</template>
<script>
export default {
  name: 'ScaleImage',
  props: {
    src: {
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  methods: {
    onLoad($event) {
      let width = $event.target.naturalWidth;
      let height = $event.target.naturalHeight;
      if (width < this.width || height < this.height) {
        return;
      }
      let widthPercent = this.width / width;
      let heightPercent = this.height / height;
      let percent = widthPercent > heightPercent ? widthPercent : heightPercent;
      width = parseInt(width * percent);
      height = parseInt(height * percent);
      $event.target.style.width = width + 'px';
      $event.target.style.height = height + 'px';
    },
  },
};
</script>
